import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionTrabajadorCuentaPropiaByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionTrabajadorCuentaPropiaByUser = () => {
  const [loadingGetDeclaracionTrabajadorCuentaPropiaByUser, setLoadingGetDeclaracionTrabajadorCuentaPropiaByUser] = useState(false);
  const [successGetDeclaracionTrabajadorCuentaPropiaByUser, setSuccessGetDeclaracionTrabajadorCuentaPropiaByUser] = useState(false);
  const [errorGetDeclaracionTrabajadorCuentaPropiaByUser, setErrorGetDeclaracionTrabajadorCuentaPropiaByUser] = useState<any>(null);
  const [dataGetDeclaracionTrabajadorCuentaPropiaByUser, setDataDeclaracionTrabajadorCuentaPropiaByUser] = useState<any>(null);

  const [statusGetDeclaracionTrabajadorCuentaPropiaByUser, setStatusGetDeclaracionTrabajadorCuentaPropiaByUser] =
    useState<StatusGetDeclaracionTrabajadorCuentaPropiaByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionTrabajadorCuentaPropiaByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionTrabajadorCuentaPropiaByUser(true);
    setSuccessGetDeclaracionTrabajadorCuentaPropiaByUser(false);
    setErrorGetDeclaracionTrabajadorCuentaPropiaByUser(null);

    try {
      const res = await apirecord.getDeclaracionTrabajadorCuentaPropiaByUser(userId, expedienteId);

      setStatusGetDeclaracionTrabajadorCuentaPropiaByUser({
        status: res.status,
        statusText: res.response
      });

      setSuccessGetDeclaracionTrabajadorCuentaPropiaByUser(true);
      setDataDeclaracionTrabajadorCuentaPropiaByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.message ||
        "Error";

      setStatusGetDeclaracionTrabajadorCuentaPropiaByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetDeclaracionTrabajadorCuentaPropiaByUser(err);
      console.error("Error en getDeclaracionTrabajadorCuentaPropiaByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionTrabajadorCuentaPropiaByUser(false);
    }
  };

  return {
    getDeclaracionTrabajadorCuentaPropiaByUser,
    loadingGetDeclaracionTrabajadorCuentaPropiaByUser,
    successGetDeclaracionTrabajadorCuentaPropiaByUser,
    errorGetDeclaracionTrabajadorCuentaPropiaByUser,
    dataGetDeclaracionTrabajadorCuentaPropiaByUser,
    statusGetDeclaracionTrabajadorCuentaPropiaByUser
  };
};

export default useGetDeclaracionTrabajadorCuentaPropiaByUser;
